import DisclosureScreen from 'features/rdc/screens/DisclosureScreen/DisclosureScreen';
import React from 'react';

export default function Page() {
  return <DisclosureScreen />;
}
